import React from "react";
import { FadeInOnScroll } from "../components/FadeInOnScroll";

const team = [
  {
    photo: "https://images.unsplash.com/photo-1612531386530-97286d97c2d2?auto=format&fit=crop&w=400&q=80",
    name: "Dr. Andrei Popescu",
    specialty: "Medic Primar Stomatolog / Director Medical",
    bio: "Absolvent al UMF „Victor Babeș” Timișoara, cu un masterat în implantologie obținut la Viena. Cu peste 12 ani de experiență, Dr. Popescu este fondatorul DentaPro Clinic și coordonatorul echipei medicale.",
    tags: ["Implantologie", "Chirurgie Orală", "Management Clinic"],
  },
  {
    photo: "https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?auto=format&fit=crop&w=400&q=80",
    name: "Dr. Mihai Ionescu",
    specialty: "Specialist Ortodonție",
    bio: "Specializat în ortodonție la Universitatea din Bologna, Dr. Ionescu tratează pacienți de toate vârstele, cu o preferință pentru tehnicile de aliniere invizibilă.",
    tags: ["Aparate fixe", "Aligneri", "Ortodonție pediatrică"],
  },
  {
    photo: "https://images.unsplash.com/photo-1559839734-2b71ea197ec2?auto=format&fit=crop&w=400&q=80",
    name: "Dr. Raluca Dănilă",
    specialty: "Specialist Estetică Dentară",
    bio: "Pasionată de estetica zâmbetului, Dr. Dănilă are o formare avansată în fațete ceramice și albire dentară, participând anual la congrese internaționale de profil.",
    tags: ["Fațete ceramice", "Albire dentară", "Coroane zirconiu"],
  },
  {
    photo: "https://images.unsplash.com/photo-1537368910025-700350fe46c7?auto=format&fit=crop&w=400&q=80",
    name: "Dr. Cristian Moga",
    specialty: "Specialist Endodonție & Stomatologie Generală",
    bio: "Cu o abordare minim-invazivă și multă răbdare, Dr. Moga este specialistul preferat al pacienților care au nevoie de tratamente de canal complexe.",
    tags: ["Endodonție", "Tratamente de canal", "Stomatologie generală"],
  },
  {
    photo: "https://images.unsplash.com/photo-1651008376811-b90baee60c1f?auto=format&fit=crop&w=400&q=80",
    name: "Dr. Elena Szabo",
    specialty: "Medic Stomatolog Pediatric",
    bio: "Dr. Szabo a ales stomatologia pediatrică pentru dragostea față de copii. Metoda ei blândă și jucăușă transformă vizita la dentist într-o experiență pozitivă pentru cei mici.",
    tags: ["Stomatologie pediatrică", "Sigilări", "Prevenție"],
  },
  {
    photo: "https://images.unsplash.com/photo-1622253692010-333f2da6031d?auto=format&fit=crop&w=400&q=80",
    name: "Dr. Florin Bucur",
    specialty: "Specialist Proteză Dentară & Implantologie",
    bio: "Cu o experiență de 8 ani în protetica dentară, Dr. Bucur realizează restaurări fixe și mobile de înaltă precizie, folosind exclusiv materiale certificate european.",
    tags: ["Proteză fixă", "Proteză mobilă", "Implantologie"],
  },
];

export default function Echipa() {
  return (
    <div data-testid="page-team">
      <section className="page-header" data-testid="team-page-header">
        <div className="container-main">
          <h1>Echipa Noastră</h1>
          <p>Specialiști dedicați sănătății tale</p>
        </div>
      </section>

      <section className="section-white">
        <div className="container-main">
          <div className="intro-block">
            <p>
              Medicii noștri sunt formați în cele mai bune centre universitare din România și
              Europa, cu specializări obținute prin ani de practică și formare continuă.
            </p>
          </div>

          <div className="team-grid">
            {team.map((m, i) => (
              <FadeInOnScroll key={i} delay={i * 70}>
                <div className="team-card" data-testid={`team-card-${i}`}>
                  <div className="team-avatar">
                    <img src={m.photo} alt={m.name} loading="lazy" />
                  </div>
                  <h3>{m.name}</h3>
                  <div className="team-specialty">{m.specialty}</div>
                  <p className="team-bio">{m.bio}</p>
                  <div className="team-tags">
                    {m.tags.map((t, j) => (
                      <span key={j} className="tag">{t}</span>
                    ))}
                  </div>
                </div>
              </FadeInOnScroll>
            ))}
          </div>

          <div className="team-banner" data-testid="team-banner">
            <div className="team-banner-icon">🎓</div>
            <p>
              Echipa noastră participă anual la cursuri de formare continuă și congrese
              internaționale pentru a vă oferi cele mai noi tehnici și tratamente.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
